import config from '../../capacitor.config';


import { Component, OnInit, NgZone } from '@angular/core';
import {AuthService, IdToken} from '@auth0/auth0-angular';

import { mergeMap } from 'rxjs/operators';
import { Browser } from '@capacitor/browser';
import { App } from '@capacitor/app';
import {PrimeNGConfig} from "primeng/api";
import {TranslateService} from "@ngx-translate/core";

import {callbackUri, clientId} from './auth.config';
import {ListPessoaComponent} from "./pages/crud/pessoa/list/list-pessoa.component";
import {Sincronizador} from "./services/sincronizacao/Sincronizador";
import {Capacitor} from "@capacitor/core";
import {LocalNotifications} from "@capacitor/local-notifications";

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit{
  public appPages = [
    // { title: 'Home', url: '/dashboard', icon: 'home' },
    { title: 'Pessoas', url: '/cadastro/pessoa', icon: 'people' },
    { title: 'Projetos', url: '/cadastro/projeto', icon: 'settings' },
    { title: 'Locais', url: '/cadastro/local', icon: 'pin'}
  ];



  registros = [
    { title: 'Indivíduos', url: '/registro/especime', icon: 'paw' },
    // { title: 'Jornada', url: '/registro/jornada', icon: 'walk' },
    { title: 'Monitoramentos', url: '/registro/monitoramento', icon: 'pulse' },
  ]
  constructor(private config: PrimeNGConfig,
              private translateService: TranslateService,
              public auth: AuthService, private ngZone: NgZone) {
      // const raw_token = localStorage.getItem("token")
      if(!this.raw_token){
        // this.token =  JSON.parse(raw_token!!) as IdToken
      // else {
        this.auth
          .loginWithRedirect({
            authorizationParams: {prompt: "login"},
            async openUrl(url: string) {
              return Browser.open({ url, windowName: '_self' });
            }
          })
          .subscribe();
      }
  }

  get token(): IdToken{
        return JSON.parse(this.raw_token) as IdToken
  }

  get raw_token(): string {
    return localStorage.getItem("token")
  }

  get agencia(): string|undefined {
    return this.token ? this.token['agencia'] : ''
  }

  logout(){
    const options = {
      clientId: clientId,
      logoutParams: {returnTo: callbackUri}
    }

    // this.auth.logout(
    //   options
    // ).subscribe(r=>{
    //     console.log('apos logout')
    //   // App.exitApp().then()
    //
    // })
    localStorage.removeItem("token")
    navigator['app'].exitApp()

  }

  component = ListPessoaComponent

  ngOnInit() {
    this.config.ripple = true;
    this.translateService.setDefaultLang('pt-br');
    this.config.setTranslation({
      accept: 'OK',
      reject: 'Cancelar',
    });
    // this.initOrmService().then()

    App.addListener('appStateChange', ({ isActive }) => {
      console.log('App state changed. Is active?', isActive);
      LocalNotifications.requestPermissions().then(r=>{
        console.log(r)
      })
      LocalNotifications.checkPermissions().then(r=>{
        console.log(r)
      })
    });


    App.addListener('appUrlOpen', ({ url }) => {
      // Must run inside an NgZone for Angular to pick up the changes
      // https://capacitorjs.com/docs/guides/angular
      this.ngZone.run(() => {
        if (url?.startsWith(callbackUri)) {
          if (
            url.includes('state=') &&
            (url.includes('error=') || url.includes('code='))
          ) {
            this.auth
              .handleRedirectCallback(url)
              .pipe(mergeMap(() => Browser.close()))
              .subscribe();
          } else {
            // navigator['app'].exitApp(true)
            // App.exitApp().then()
            Browser.close();
          }
        }
      });
    });
  }

  // async initOrmService() {
  //   try {
  //     await this.ormService.initialize();
  //     console.log(`*** ORM service has been initialized ***`)
  //   } catch(err: any) {
  //     const msg = err.message ? err.message : err
  //     throw new Error(`Error: ${msg}`);
  //   }
  // }

}
